// extracted by mini-css-extract-plugin
export default {"container":"DynamicIndicator_container__V51Xd","imageContainer":"DynamicIndicator_imageContainer__EhdUI","reversed":"DynamicIndicator_reversed__w-P+d"};